import axios from 'axios'
import {GenericAbortSignal} from 'axios'
import {API_DELAY_MS} from '@/utils/constants'
import {checkAuth} from '@/utils/helpers'

type GetHeaderNotificationsProps = {
  nPageNo?: number,
  SEQ?: string,
  signal: GenericAbortSignal,
}

export const getHeaderNotifications: ({nPageNo, SEQ, signal}: GetHeaderNotificationsProps) => any = async ({nPageNo = 1, SEQ = '', signal}) => {
  await new Promise((resolve) => setTimeout(resolve, API_DELAY_MS))
  const apiUrl =
    process.env.NEXT_PUBLIC_AFEVENT +
    '/api/notification.php?szWork=getNotifications&nPageNo=' +
    nPageNo +
    '&nFromIdx=' +
    SEQ

  const response: any = await axios.get(apiUrl, {
    withCredentials: true,
    signal,
  })

  return response?.data || null
}

type ReadNotificationProps = {
  seq: string,
}

export const readNotification = async ({seq}: ReadNotificationProps) => {
  if (!checkAuth()) {
    throw new Error('Auth Error')
  }

  try {
    const formData = new FormData()
    formData.append('szWork', 'postFeed')
    formData.append('szActionType', 'read')
    formData.append('nSequence', seq)

    const apiUrl =
      process.env.NEXT_PUBLIC_AFEVENT +
      '/api/notification.php?szWork=postFeed&szActionType=read'
    const response = await axios.post(apiUrl, formData, {
      withCredentials: true,
    })

    return response?.data ? response?.data : null
  } catch (error) {
    console.log(error)
  }
}

type ReadAllNotificationProps = {
  seq: string,
}

export const readAllNotification = async ({seq}: ReadAllNotificationProps) => {
  if (!checkAuth()) {
    throw new Error('Auth Error')
  }

  try {
    const formData = new FormData()
    formData.append('szWork', 'postFeed')
    formData.append('szActionType', 'read_all')
    formData.append('nSequence', seq)

    const apiUrl =
      process.env.NEXT_PUBLIC_AFEVENT +
      '/api/notification.php?szWork=postFeed&szActionType=read_all'
    const response = await axios.post(apiUrl, formData, {
      withCredentials: true,
    })

    return response?.data ? response?.data : null
  } catch (error) {
    console.log(error)
  }
}

type DeleteNotificationProps = {
  seq: string,
}

export const deleteNotification = async ({seq}: DeleteNotificationProps) => {
  if (!checkAuth()) {
    throw new Error('Auth Error')
  }

  try {
    const formData = new FormData()
    formData.append('szWork', 'postFeed')
    formData.append('szActionType', 'delete')
    formData.append('nSequence', seq)

    const apiUrl =
      process.env.NEXT_PUBLIC_AFEVENT +
      '/api/notification.php?szWork=postFeed&szActionType=delete'
    const response = await axios.post(apiUrl, formData, {
      withCredentials: true,
    })

    return response?.data ? response?.data : null
  } catch (error) {
    console.log(error)
  }
}

type DeleteAllReadNotificationProps = {
  seq: string,
}

export const deleteAllReadNotifications = async ({seq}: DeleteAllReadNotificationProps) => {
  if (!checkAuth()) {
    throw new Error('Auth Error')
  }

  try {
    const formData = new FormData()
    formData.append('szWork', 'postFeed')
    formData.append('szActionType', 'delete_read')
    formData.append('nSequence', seq)

    const apiUrl =
      process.env.NEXT_PUBLIC_AFEVENT +
      '/api/notification.php?szWork=postFeed&szActionType=delete_read'
    const response = await axios.post(apiUrl, formData, {
      withCredentials: true,
    })

    return response?.data ? response?.data : null
  } catch (error) {
    console.log(error)
  }
}

type DeleteAllNotificationProps = {
  seq: string,
}

export const deleteAllNotifications = async ({seq}: DeleteAllNotificationProps) => {
  if (!checkAuth()) {
    throw new Error('Auth Error')
  }

  try {
    const formData = new FormData()
    formData.append('szWork', 'postFeed')
    formData.append('szActionType', 'delete_all')
    formData.append('nSequence', seq)

    const apiUrl =
      process.env.NEXT_PUBLIC_AFEVENT +
      '/api/notification.php?szWork=postFeed&szActionType=delete_all'
    const response = await axios.post(apiUrl, formData, {
      withCredentials: true,
    })

    return response?.data ? response?.data : null
  } catch (error) {
    console.log(error)
  }
}

type GetGuidesListProps = {
  pageNo: number,
  signal: GenericAbortSignal,
}

export const getGuidesList = async ({pageNo, signal}: GetGuidesListProps) => {
  try {
    const apiUrl =
      process.env.NEXT_PUBLIC_LIVE +
      '/api/vtvlive/portlet.php?p_id=onlive_notice&pageno=' +
      pageNo
    const response = await axios.get(apiUrl, {
      signal,
    })

    return response?.data ? response?.data : null
  } catch (error) {
    console.log(error)
  }
}
